// Copyright (c) 2023 embyt GmbH. All rights reserved.
// Author: Marc Planeck
import * as React from "react";

import AppStateView from "view/comp/AppState";
import UserSignUp from "view/comp/UserSignUp";
import LoginLayout from "view/layout/LoginLayout";

declare const IS_CLOUD: boolean;

export default function SignUp() {
  return (
    <LoginLayout>
      {IS_CLOUD && <UserSignUp />}
      <AppStateView />
    </LoginLayout>
  );
}
